import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class MmcModelHistoryGridLayoutService {

    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [
            {
                headerName: "Timestamp",
                field: "modifiedOn",
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
                minWidth: 150,
                flex: 2,
                suppressMovable: true,
                sort: 'desc',
                comparator: this.sortDate.bind(this)
            },
            {
                headerName: "User",
                field: "modifiedBy",
                minWidth: 70,
                flex: 1,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: false
            },
            {
                headerName: "Symbol",
                field: "securitySymbol",
                minWidth: 50,
                flex: 1,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: false

            },
            {
                headerName: "Description",
                field: "securityDescription",
                minWidth: 100,
                flex: 1,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: false
            },
            {
                headerName: "Attribute",
                field: "attribute",
                minWidth: 50,
                flex: 1,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: false
            },
            {
                headerName: "Previous Value",
                field: "previousValue",
                suppressMovable: false,
                cellRenderer: 'cellRendererFormatter',
                flex: 1,
            },
            {
                headerName: "Updated Value",
                field: "updatedValue",
                suppressMovable: false,
                cellRenderer: 'cellRendererFormatter',
                flex: 1,
            }
        ];
    }
    sortDate(a: any, b: any) {
        if (a === null || typeof a === "undefined") {
            return -1;
        } else if (b === null || typeof b === "undefined") {
            return 1;
        } else {
            a = new Date(a).getTime();
            b = new Date(b).getTime();
            return a < b ? -1 : a > b ? 1 : 0;
        }
    }
}
